import React from 'react';

const faqs = [
  {
    question: 'Who is Oko Ag?',
    answer:
      'Oko Ag is a technology company dedicated to helping UK farmers navigate funding opportunities. We aggregate and organise information about public and private farm funding opportunities to make it easier to find the right funding for their farm business.'
  },
  {
    question: 'Is Oko linked to DEFRA or other funders?',
    answer:
      'No, Oko Ag operates independently. We are not affiliated with DEFRA or any funding bodies. We compile information about funding opportunities to help farmers make informed decisions about which to pursue.'
  },
  {
    question: 'How do we use your data',
    answer:
      'We take your privacy seriously. Your data is used solely to provide you with relevant funding opportunities and improve our service. We never sell your information to third parties. You can view our full privacy policy for detailed information about how we collect, store, and use your data.'
  },
  {
    question: 'How much does it cost?',
    answer:
      'Creating an account and browsing funding opportunities is completely free. We believe all farmers should have access to information about available funding without barriers. Premium features may be added in the future.'
  },
  {
    question: 'What areas do you cover?',
    answer:
      'Right now, we are mainly focused on England, but we are constantly adding new opportunities. Our aim is to cover all public and private funding opportunities across the UK.'
  },
  {
    question: 'How do I get my funding opportunities listed?',
    answer:
      'We are building a comprehensive database of funding opportunities for UK farmers. Email us at hello@oko.ag to have your opportunity included.'
  }
];

const FAQPage = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-12">
      <h1 className="text-2xl sm:text-4xl font-bold text-gray-900 mb-6 sm:mb-8" style={{ fontFamily: "'Poppins', system-ui, sans-serif" }}>
        Frequently Asked Questions
      </h1>
      <div className="space-y-6">
        {faqs.map((faq, idx) => (
          <div key={idx} className="border-b border-gray-200 pb-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-2" style={{ fontFamily: "'Poppins', system-ui, sans-serif" }}>
              {faq.question}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {faq.answer}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQPage;
